export const state = {
  layoutType: 'vertical',
  layoutWidth: 'default',
  leftSidebarTheme: 'default',
  leftSidebarType: 'fixed',
}

export const getters = {}
